export default __webpack_public_path__ + "static/media/seller-bg.3de53b7d.jpg";